import { HEAP_ID_DEV_STAGE, HEAP_ID_PROD } from "./heap";
import { RESPONSE_TYPE as responseType, SCOPE as scope, AUDIENCE as audience } from "./authentication";

const isPkceFlowMode = false;
const softwareVersion = '1.0.0';

export {
  HEAP_ID_DEV_STAGE,
  HEAP_ID_PROD,
  responseType,
  scope,
  audience,
  isPkceFlowMode,
  softwareVersion
}
